import styled from 'styled-components';
import { ControlbarPopoverWrapper as ControlbarPopover } from 'containers/ThemeDefault/styled';
import { FlexRowCenter } from '@styles/global-styles';

export const ThemeBaseKrpanoWrapper = styled.div`
  width: 100%;
  height: 100%;
  color: var(--color-text);
  ${FlexRowCenter};
  position: relative;
`;

export const HeaderWrapper = styled.header`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  padding: 12px;
  pointer-events: none;
  .--logo {
    width: 100%;
    display: flex;
    cursor: pointer;
    &.topLeft {
      justify-content: flex-start;
    }
    &.topCenter {
      justify-content: center;
    }
    &.topRight {
      justify-content: flex-end;
    }
    img {
      width: 100%;
      height: auto;
      pointer-events: auto;
      max-height: max-content;
    }
    @media (max-width: 575px) {
      img {
        max-width: 45vw;
      }
    }
  }
`;

export const ControlbarWrapper = styled.div`
  position: absolute;
  bottom: 8px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: max-content;
  transform: translateY(0);
  transition: var(--transition-smooth);
  transition-duration: 0.5s;
  width: 100%;
  max-width: 60%;
  z-index: 10;
  @media (max-width: 1025px) {
    max-width: 72%;
  }
  @media (max-width: 769px) {
    max-width: 90%;
    bottom: 42px;
  }
  @media (max-width: 575px) {
    max-width: 95%;
    bottom: 42px;
    &.--controlbar-off {
      bottom: 0px;
    }
  }

  &.--controlbar {
    &-off {
      transform: translateY(100%);
      bottom: 0px;
    }
  }

  .--title {
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: auto;
    width: 100%;
    > * {
      font-size: 16px;
      color: var(--color-text);
      font-weight: 700;
      text-shadow: 0 2px 6px rgb(0 0 0 / 0.5);
      margin-bottom: 0.5rem;
      @media (max-width: 575px) {
        margin-bottom: 0.25rem;
      }
    }
  }

  .--mainPanel {
    background: var(--color-primary);
    color: var(--color-text);
    padding: 0 0.25rem;
    border-radius: 8px;
    transition: var(--transition-regular);
    @media (max-width: 575px) {
    }
    .controlBar {
      display: flex;
      justify-content: space-between;
      > * {
        display: flex;
      }
      .itemControlBtn {
        width: 2.5rem;
        height: 2.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.25rem;
        margin-right: 0.5rem;
        border-radius: 25px;
        cursor: pointer;
        transition: var(--transition-regular);
        color: var(--color-text);
        border: none;
        background: none;
        @media (hover: hover) and (pointer: fine) {
          &:hover {
            background: rgb(0 0 0 / 0.1);
            text-shadow: 0 0 20px #fff;
            i {
              font-weight: 900;
            }
          }
        }
        &.active {
          background: rgb(0 0 0 / 0.25);
          text-shadow: 0 0 20px #fff;
          i {
            font-weight: 900;
          }
        }

        &:last-child {
          margin-right: 0;
        }

        @media (max-width: 575px) {
          margin-right: 0;
          width: 2.25rem;
          height: 2.25rem;
        }
      }

      .itemShowControlbar {
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        transition: var(--transition-smooth);
        transition-delay: 0.25s;
        text-shadow: 0 2px 6px rgb(0 0 0 / 0.25);
        font-size: 2rem;
        &.--hide {
          opacity: 0;
          bottom: -40px;
          transition-delay: 0s;
        }
        @media (max-width: 575px) {
          bottom: 110%;
        }
      }
    }
  }
`;

export const ControlbarPopoverWrapper = styled(ControlbarPopover)``;

export const SideToolbarWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  height: max-content;
  background: var(--color-primary);
  color: var(--color-text);
  padding: 6px 0;
  border-radius: 8px 0 0 8px;
  z-index: 10;

  @media (max-width: 640px) {
    top: 15%;
    bottom: initial;
    padding: 0.25rem 0.25rem;
  }

  .itemSideBtn {
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
    border-radius: 25px;
    margin: 0.5rem 0;
    transition: var(--transition-regular);
    cursor: pointer;
    color: var(--color-text);
    @media (hover: hover) and (pointer: fine) {
      &:hover {
        text-shadow: 0 0 20px #fff;
        i {
          font-weight: 900;
        }
      }
    }
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
    @media (max-width: 575px) {
      width: 2.25rem;
      height: 2.25rem;
    }
  }
`;

export const CopyrightWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  background: linear-gradient(90deg, #000, rgb(0 0 0 / 0));
  padding: 0.5rem 2.5rem 0.5rem 0.5rem;
  color: var(--color-text);
  z-index: 10;
  * {
    color: var(--color-text);
  }
  > span {
    display: block;
    text-transform: uppercase;
    font-size: 80%;
    letter-spacing: 1px;
    opacity: 0.75;
  }
  @media (max-width: 575px) {
    > span {
      display: inline;
    }
  }

  a {
    font-weight: 700;
  }
`;

export const ListSceneWrapper = styled.div`
  transition: var(--transition-smooth);
  height: 120px;
  overflow: hidden;
  z-index: 10;
  padding: 0.5rem 0.25rem;
  &.hideNav {
    height: 80px;
  }

  &.--hide {
    height: 0;
    padding: 0 0.25rem;
  }
  .--tabs {
    .ant-tabs {
      &-nav {
        margin: 0;
        &:before {
          border: none;
        }
        &-more {
          color: #fff;
        }
      }
      &-tab {
        margin: 0 0 0.5rem;
        padding: 3px 6px;
        border-radius: 4px;
        border: 1px solid rgb(255 255 255 / 0.35);
        margin-right: 0.5rem;
        cursor: pointer;
        transition: var(--transition-regular);
        color: var(--color-text);
        @media (hover: hover) and (pointer: fine) {
          &:hover {
            border-color: rgb(255 255 255 / 0.5);
          }
        }
        &-active {
          background: #fff;
          color: var(--color-primary);
        }
      }
      &-ink-bar {
        display: none;
      }
    }
    @media (max-width: 575px) {
      padding: 0 0.25rem;
      /* flex-wrap: nowrap;
      overflow: auto; */
      .ant-tabs-tab {
        flex: 0 0 auto;
      }
    }
  }

  .itemScene {
    width: 20%;
    max-width: 132px;
    height: 72px;
    border-radius: 2px;
    overflow: hidden;
    position: relative;
    border: 2px solid rgb(0 0 0 / 0.2);
    margin: 0 0.25rem;
    transition: var(--transition-regular);
    cursor: pointer;
    @media (hover: hover) and (pointer: fine) {
      &:hover {
        border-color: rgb(0 0 0 / 0.5);
      }
    }

    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }

    &.active {
      border-color: var(--color-text);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      background: rgba(0, 0, 0, 1);
    }

    span {
      position: absolute;
      bottom: 0;
      padding: 0.25rem 0.75rem;
      display: block;
      width: 100%;
      text-align: center;
      color: var(--color-text);
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 0.75rem;
      text-shadow: 0 2px 3px rgb(0 0 0 / 0.35);
      font-weight: 600;
    }
    @media (max-width: 575px) {
      width: 40%;
    }
  }
`;
